export default __webpack_public_path__ + "static/media/brave.e27f75f8.mp4";